var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuestion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C4.22876 16 2.34315 16 1.17157 14.8284C0 13.6569 0 11.7712 0 8C0 4.22876 0 2.34315 1.17157 1.17157C2.34315 0 4.22876 0 8 0C11.7712 0 13.6569 0 14.8284 1.17157C16 2.34315 16 4.22876 16 8C16 11.7712 16 13.6569 14.8284 14.8284C13.6569 16 11.7712 16 8 16ZM8 4.6C7.50294 4.6 7.1 5.00294 7.1 5.5C7.1 5.83137 6.83137 6.1 6.5 6.1C6.16863 6.1 5.9 5.83137 5.9 5.5C5.9 4.3402 6.8402 3.4 8 3.4C9.1598 3.4 10.1 4.3402 10.1 5.5C10.1 6.06867 9.87317 6.58558 9.50637 6.96317C9.43255 7.03915 9.36215 7.1095 9.29498 7.17661C9.12231 7.34913 8.97104 7.50027 8.83832 7.6708C8.6631 7.89594 8.6 8.06141 8.6 8.2V8.8C8.6 9.13137 8.33137 9.4 8 9.4C7.66863 9.4 7.4 9.13137 7.4 8.8V8.2C7.4 7.67585 7.64401 7.25155 7.89133 6.93377C8.07434 6.69863 8.30435 6.46907 8.49102 6.28277C8.54733 6.22657 8.5997 6.17431 8.64564 6.12702C8.80367 5.96435 8.9 5.74404 8.9 5.5C8.9 5.00294 8.49706 4.6 8 4.6ZM8 12C8.44183 12 8.8 11.6418 8.8 11.2C8.8 10.7582 8.44183 10.4 8 10.4C7.55817 10.4 7.2 10.7582 7.2 11.2C7.2 11.6418 7.55817 12 8 12Z",
    fill: "#06320A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Question.c6046a1d.svg";
export { ForwardRef as ReactComponent };